import { render, staticRenderFns } from "./SizeSpecDetail.vue?vue&type=template&id=9038974a&"
import script from "./SizeSpecDetail.vue?vue&type=script&lang=js&"
export * from "./SizeSpecDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports